module.exports = __webpack_public_path__ + "img/code.4bd14647.png";